export default {
  Yes: 'Tak',
  No: 'Nie',
  Save: 'Zapisz',
  Cancel: 'Odrzuć',
  loginPage: {
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    email: 'Email',
    logIn: 'Zaloguj',
    registry: 'Zarejetruj',
    hello: 'Witaj {{name}}!',
    loginPrompt: 'Zaloguj się aby zacząć używać szukadła.',
    backToLogin: 'Powrót',
    error: {
      withoutRequiredData: 'Brak wymaganych danych',
      worngLoginCredentials: 'Błędne dane logowania',
      unexpected: 'Wystąpił nieoczekiwany błąd',
      emailRequired: 'Email jest wymagany',
      invalidEmail: 'Nieprawidłowy format adresu email',
      passwordRequired: 'Hasło jest wymagane',
      passwordNeedsUppercase: 'Hasło musi zawierać wielką literę',
      passwordNeedsNumber: 'Hasło musi zawierać cyfrę',
      invalidOtp: 'Nieprawidłowy kod weryfikacyjny',
      invalidUnblockCode: 'Nieprawidłowy kod odblokowania',
    },
    otp: {
      title: 'Weryfikacja dwuetapowa',
      sentToEmail: 'Kod weryfikacyjny został wysłany na Twój adres email.',
      useAuthApp: 'Wprowadź kod z aplikacji uwierzytelniającej.',
      codeLabel: 'Kod weryfikacyjny',
      verify: 'Zweryfikuj',
      resend: 'Wyślij ponownie kod',
      resendIn: 'Wyślij ponownie za {{seconds}}s',
    },
    blocked: {
      title: 'Konto zablokowane',
      description: 'Twoje konto zostało zablokowane. Sprawdź email i wprowadź kod odblokowania.',
      codeLabel: 'Kod odblokowania',
      unblock: 'Odblokuj konto',
      success: 'Konto zostało odblokowane. Możesz się teraz zalogować.',
    },
    passkey: {
      or: 'lub',
      signIn: 'Zaloguj się kluczem dostępu',
      error: {
        failed: 'Logowanie kluczem dostępu nie powiodło się',
        blocked: 'Twoje konto zostało zablokowane. Zaloguj się hasłem, aby je odblokować.',
      },
    },
  },
  profilePage: {
    passkeys: {
      title: 'Klucze dostępu',
      intro:
        'Klucze dostępu pozwalają logować się bez hasła — odciskiem palca, twarzą lub kodem PIN urządzenia. Możesz dodać osobny klucz na każdym urządzeniu.',
      add: 'Dodaj klucz dostępu',
      empty: 'Nie masz jeszcze żadnych kluczy dostępu.',
      unnamed: 'Klucz bez nazwy',
      lastUsed: 'Ostatnio użyty: {{date}}',
      created: 'Utworzono: {{date}}',
      rename: 'Zmień nazwę',
      delete: 'Usuń',
      nameDialog: {
        addTitle: 'Nazwij klucz dostępu',
        renameTitle: 'Zmień nazwę klucza',
        label: 'Nazwa',
        defaultName: 'Nowy klucz',
        save: 'Zapisz',
        cancel: 'Anuluj',
      },
      deleteDialog: {
        title: 'Usunąć klucz dostępu?',
        warning:
          'Klucz „{{name}}” przestanie działać na wszystkich Twoich urządzeniach. Można to cofnąć jedynie dodając nowy klucz.',
        confirm: 'Usuń',
        cancel: 'Anuluj',
      },
      snackbar: {
        added: 'Dodano klucz dostępu',
        renamed: 'Zmieniono nazwę klucza',
        deleted: 'Usunięto klucz dostępu',
      },
      error: {
        loadFailed: 'Nie udało się pobrać kluczy dostępu.',
        retry: 'Spróbuj ponownie',
        generic: 'Wystąpił błąd. Spróbuj ponownie.',
        alreadyRegistered: 'To urządzenie ma już zapisany klucz dostępu dla tego konta.',
      },
    },
  },
  registryPage: {
    hello: 'Miło nam Cię poznać {{name}}!',
    username: 'Nazwa użytkownika',
    password: 'Hasło',
    registry: 'Zarejetruj',
    email: 'Email',
    firstName: 'Imię',
    repeatPassword: 'Powtórz hasło',
    error: {
      withoutRequiredData: 'Brak wymaganych danych',
      toShortPassword: 'Zbyt krótkie hasło',
      badEmail: 'Podano błędny adres email',
      unexpected: 'Wystąpił nieoczekiwany błąd',
      passwordsShouldEquals: 'Hasła powinny być takie same',
      duplicatedUsernameOrMail: "Użytkownik o podanym email'u bądź nazwię użytkownika już istnieje",
    },
  },
  searchMenu: {
    placeholder: 'Czego szukasz?',
    searchFor: 'Szukaj „{{phrase}}”',
  },
  addBox: {
    filesCount_0: 'Wybrano {{count}} plik',
    filesCount_1: 'Wybrano {{count}} pliki',
    filesCount_2: 'Wybrano {{count}} plików',
  },
  addPhotos: {
    sendingPhotosTitle: 'Przesyłanie zdjęć',
    sendingPhotosDescription:
      'Trwa przesyłanie i automatyczne tagowaine zdjęć, ten proces może chwilę trwać, proszę nie opuszczaj tej strony dopóki proces nie dobiegnie końca',
    description: 'Wybierz i dodaj swoje zdjęcia!',
    showPreview: 'Zobacz zdjęcia',
    hidePreview: 'Ukryj zdjęcia',
    startImageSend: 'Rozpocznij przesyłanie',
    photosSendDoneTitle: 'Zdjęcia zostały wysłane!',
    photosSendDoneDesc: 'Twoje zdjęcia są już gotowe do wyszukania, na co czekasz?!',
    error: {
      error: 'Wystąpił błąd 😮',
      limit:
        'Zużyto limit przesłanych zdjęć, w celu odnowienia limitu skontaktuj się z administratorem',
    },
  },
  loading: {
    text: 'Ładowanie...',
    video: 'Ładowanie wideo...',
    searching: 'Wyszukiwanie...',
  },
  navBar: {
    selectTheme: 'Wybierz motyw',
    selectLanguage: 'Zmień język strony / Change website language',
    logout: 'Czy na pewno chcesz się wylogować?',
    profileTitle: 'Witaj {{name}}!',
    profileDesc: 'Tutaj możesz uzupełnić bądź zaktualizować swoje dane',
    avatarChange: 'Zmień avatar',
    adminPanel: 'Przejdź do panelu admina',
  },
  admin: {
    panel: 'Panel administratora',
    photos: 'Zdjęcia: {{count}}',
    user: 'Użytkownik',
    admin: 'Administrator',
  },
  photos: {
    hereYouWillSeeYourPhotos: 'Tutaj pojawią się twoje zdjęcia',
  },
  gallery: {
    today: 'Dzisiaj',
    yesterday: 'Wczoraj',
    groupByDate: 'Grupuj według dat',
  },
  galleryOptions: {
    title: 'Opcje galerii',
    layout: 'Układ',
    layoutJustified: 'Rzeka',
    layoutMasonry: 'Mozaika',
    grouping: 'Grupowanie',
    byDate: 'Według dat',
    continuous: 'Ciągły',
  },
  gallerySort: {
    title: 'Sortowanie',
    by: 'Sortuj według',
    order: 'Kolejność',
    dateTaken: 'Data wykonania',
    dateUploaded: 'Data przesłania',
    dateAddedToAlbum: 'Data dodania',
    desc: 'Od najnowszych',
    asc: 'Od najstarszych',
  },
  filters: {
    button: 'Filtry',
    title: 'Filtry',
    apply: 'Zastosuj',
    clearAll: 'Wyczyść filtry',
    query: 'Fraza',
    queryPlaceholder: 'Wpisz frazę...',
    album: 'Album',
    persons: 'Osoby',
    personsPlaceholder: 'Dodaj osobę...',
    users: 'Wysłane przez',
    usersPlaceholder: 'Dodaj użytkownika...',
    device: 'Urządzenie',
    devicePlaceholder: 'Wybierz urządzenie...',
    type: 'Typ',
    typeImage: 'Zdjęcia',
    typeVideo: 'Filmy',
    dateFrom: 'Od',
    dateTo: 'Do',
    noResults: 'Brak wyników',
    typeToSearch: 'Zacznij pisać, aby wyszukać',
  },
  dropZone: {
    dropHere: 'Upuść pliki, aby przesłać',
    supportedFormats: 'Zdjęcia i filmy',
  },
  deleteAccount: {
    title: 'Usuń konto',
    description:
      'Podaj adres email konta Szukadło. Wyślemy na niego link do potwierdzenia. Po potwierdzeniu konto zostanie zablokowane, a następnie usunięte.',
    emailLabel: 'Email',
    submit: 'Wyślij link potwierdzający',
    sent: 'Jeśli konto z tym adresem istnieje, wysłaliśmy na nie link potwierdzający. Link jest ważny 24 godziny.',
    confirmTitle: 'Potwierdź usunięcie konta',
    confirmDescription: 'Po potwierdzeniu konto zostanie zablokowane, a następnie usunięte.',
    confirm: 'Potwierdź usunięcie konta',
    confirmed: 'Konto zostało zablokowane i wkrótce zostanie usunięte.',
    invalidLink: 'Ten link jest nieprawidłowy.',
    expired: 'Link wygasł albo został już użyty.',
    requestNewLink: 'Wyślij nowy link',
    error: {
      invalidEmail: 'Nieprawidłowy format adresu email',
      tooManyRequests: 'Zbyt wiele prób. Spróbuj ponownie za chwilę.',
      unexpected: 'Wystąpił nieoczekiwany błąd',
    },
  },
}
